import './App.css';
import './styles/font.css';
import { BrowserRouter as Router } from 'react-router-dom';
import ErrorBoundary from './components/Error/ErrorBoundary';
import { AuthProvider, LanguageProvider, StalePageModal, StalePageProvider } from '@repo/common';
import AppInner from './AppInner';

function App() {
  return (
    <Router>
      <StalePageProvider>
        <ErrorBoundary>
          <AuthProvider>
            <LanguageProvider>
              <AppInner />
              <StalePageModal />
            </LanguageProvider>
          </AuthProvider>
        </ErrorBoundary>
      </StalePageProvider>
    </Router>
  );
}

export default App;
